import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { SubmitButton } from 'parking-availability/js/ui/Button'

import { themeFontSize, themeFontWeight, Copy, Currency } from '@elparking/components'

import { MoneyType } from 'parking-availability/js/propTypes'

import messages from './messages'

const StyledAmount = styled.span`
    font-size: ${themeFontSize('xLarge')};
    font-weight: ${themeFontWeight('medium')};
`

const StyledCurrency = styled.span`
    font-size: ${themeFontSize('medium')};
    font-weight: ${themeFontWeight('regular')};
`

const hasPrice = (priceQty) => priceQty && priceQty.amount !== null && priceQty.amount !== undefined

class PriceButton extends PureComponent {
    static propTypes = {
        priceQty: MoneyType,
        isLoading: PropTypes.bool,
        isDisabled: PropTypes.bool,
        onClick: PropTypes.func,
    }

    static defaultProps = {
        isLoading: false,
        isDisabled: false,
        onClick: () => {},

    }

    renderPrice () {
        const { priceQty } = this.props

        if (!hasPrice(priceQty)) {
            return (
                <Copy as='span' padding='0' fontWeight='medium' size='medium' color='white'>
                    <FormattedMessage {...messages.searchButtonTitle} />
                </Copy>
            )
        }

        return (
            <span>
                <Currency qty={priceQty} amountWrapper={StyledAmount} currencyWrapper={StyledCurrency} />
                <Copy as='span' padding='0 0 0 20px' fontWeight='medium' size='medium' color='white'>
                    <FormattedMessage {...messages.searchButtonTitle} />
                </Copy>
            </span>
        )
    }

    render () {
        const { isLoading, isDisabled, onClick } = this.props

        return (
            <SubmitButton dataTest='pay-booking-button' width='100%' loading={isLoading} disabled={isDisabled} onClick={onClick}>
                {this.renderPrice()}
            </SubmitButton>
        )
    }
}

export default PriceButton
